import { render, staticRenderFns } from "./CustomTreeSelect.vue?vue&type=template&id=3dbcdb3c&"
import script from "./CustomTreeSelect.vue?vue&type=script&lang=js&"
export * from "./CustomTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports